import { useQuery } from "@tanstack/react-query";
import { fetchProfileSettingsProfile } from "../services/profileSettingsService";

export default function useProfileSettingsProfile() {
  return useQuery({
    queryKey: ["profileSettingsProfile"],
    queryFn: fetchProfileSettingsProfile,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  });
}
